import axios from 'axios';

const API_BASE_URL = '/defensenuggets/api';

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

/**
 * Fetch decisions for a specific week
 * @param {string} startDate - The start date of the week (YYYY-MM-DD)
 * @returns {Promise<Object>} - Weekly decisions data
 */
export const fetchWeeklyDecisions = async (startDate = null) => {
  const params = startDate ? { start: startDate } : {};
  try {
    const response = await api.get('/decisions/weekly/', { params });
    return response.data;
  } catch (error) {
    console.error('Error fetching weekly decisions:', error);
    throw error;
  }
};

/**
 * Fetch a specific decision's details
 * @param {number} id - The decision ID
 * @returns {Promise<Object>} - Decision details
 */
export const fetchDecisionDetail = async (id) => {
  try {
    const response = await api.get(`/decisions/${id}/`);
    return response.data;
  } catch (error) {
    console.error(`Error fetching decision ${id}:`, error);
    throw error;
  }
};

/**
 * Fetch all circuit courts
 * @returns {Promise<Array>} - List of circuits
 */
export const fetchCircuits = async () => {
  try {
    const response = await api.get('/circuits/');
    return response.data;
  } catch (error) {
    console.error('Error fetching circuits:', error);
    throw error;
  }
};

/**
 * Fetch comprehensive statistics about decisions
 * @returns {Promise<Object>} - Statistics data
 */
export const fetchStats = async () => {
  try {
    const response = await api.get('/decisions/stats/');
    return response.data;
  } catch (error) {
    console.error('Error fetching stats:', error);
    throw error;
  }
};

export default api;